/****************************************************
 * Module Name:  addBoxModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg';
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import Select from "react-select";
import SaveIcon from '@mui/icons-material/Save';

export default class AddBoxModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            locationid: this.props.editOperation ? this.props.sourceData.locationid : "",
            capacity: this.props.editOperation ? this.props.sourceData.capacity : "",

            locationOptions: [],
            locationName: {},

            showError: false,
            fullNameValidationError: "",
        };

        this.handleSearch();
    }

    handleSearch = () => {
        LocationProxy.GetAllLocationDetailMini((response) => {
            this.setAllLocationData(response);
        })
    }

    setAllLocationData = (response) => {
        let optionsArray = [];
        let tempOption = {};
        response.map((data) => {
            let option = { value: data.id, label: data.name };
            if (data.id === this.props.sourceData.locationid) {
                tempOption = option;
            }
            optionsArray.push(option);
            return true;
        });
        this.setState({
            locationOptions: optionsArray,
            locationName: this.props.editOperation ? tempOption : optionsArray[0]
        });
    };

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            locationid: this.state.locationName.value,
            capacity: this.state.capacity,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    buttonDisable = () => {
        if (this.props.editOperation && ((this.state.capacity === this.props.sourceData.capacity && this.state.locationName.value === this.state.locationid) || (this.state.capacity < 0)))
            return true;

        if (!this.props.editOperation && (this.state.capacity < 0 || this.state.capacity === ""))
            return true;

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add box validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit box" : "Add New box"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Box Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label>{this.props.sourceData.id}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Location <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                value={this.state.locationName}
                                                isSearchable={true}
                                                name="Location"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.locationOptions}
                                                onChange={(selectedOption) => this.setState({
                                                    locationName: selectedOption
                                                })}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Capacity<sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                required
                                                fullWidth
                                                size="small"
                                                label="Capacity"
                                                placeholder="Enter Capacity"
                                                value={this.state.capacity}
                                                onChange={(e) =>
                                                    this.setState({
                                                        capacity: e.target.value,
                                                        fullNameValidationError: Utility.CheckIsPresent(e.target.value)
                                                            ? (e.target.value < 0 ? "Capacity Cannot be less than 0" : "")
                                                            : "Capacity Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.fullNameValidationError}
                                                error={this.state.fullNameValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
